import { MetadataType } from "@/types/MetadataType";

export enum ChatMessageFragmentType {
  STRING = "STRING",
  FINANCIAL_STATEMENT_ITEM = "FINANCIAL_STATEMENT_ITEM",
  CHART = "CHART",
  JSON = "JSON",
  HTML = "HTML",
  MARKDOWN = "MARKDOWN",
  INVITED_USERS_ARRAY = "INVITED_USERS_ARRAY",
  REMOVED_USERS_ARRAY = "REMOVED_USERS_ARRAY",
  FUNDER = "FUNDER",
  CHAT_MEMBER_LEFT = "CHAT_MEMBER_LEFT",
  CHAT_BEGINNING = "CHAT_BEGINNING",
  ROOM_DOCUMENT = "ROOM_DOCUMENT",
  SHARED_FINANCIALS = "SHARED_FINANCIALS",
  FINALIZED_THREAD = "FINALIZED_THREAD",
  FILE = "FILE",
  /**
   * Audit-only marker emitted when a disabled user is silently removed from a group chat.
   * Not rendered in the UI; persisted purely so the removal is traceable in chat history.
   */
  SILENT_MEMBER_REMOVED = "SILENT_MEMBER_REMOVED",
}

export type ChatMessageFragment = {
  content: any;
  type: ChatMessageFragmentType;
  tag?: MetadataType;
};
